import PropTypes from "prop-types";

import Icon from "assets/svg/long-down.svg";

import styles from "./styles.module.css";

const PriceTrend = ({ data }) => {
  const handleClick = () => {
    window.scrollTo({
      top: document.getElementById("fiyat-bilgisi").offsetTop - 100 /* 100 => sticky header size */,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className={styles.wrapper} onClick={handleClick}>
      {`%${data}`}
      <span className={styles.iconWrap}>
        <Icon />
      </span>
    </div>
  );
};

PriceTrend.propTypes = {
  data: PropTypes.number,
};

export default PriceTrend;
